module.exports = __webpack_public_path__ + "img/Verkehrslotse.1c8b04e8.svg";